/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Max_Rounds_No_LimitInputs */



/**
* | output |
* | --- |
* | "No limit" |
*
* @param {Tfield_Max_Rounds_No_LimitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_max_rounds_no_limit = /** @type {((inputs?: Tfield_Max_Rounds_No_LimitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Max_Rounds_No_LimitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de limite")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin límite")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem limite")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun limite")
	return /** @type {LocalizedString} */ ("No limit")
});